import { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import Logo from "../../components/common/loading/logo/Logo";
import HeaderNav from "../../components/nav/HeaderNav";
import UserWidget from "../../components/user/UserWidget";

const PortalLayout: FC<PropsWithChildren> = ({ children }) => {

  return (
    <div className="bg-white min-h-[100vh]">
      <div className="h-[100px] bg-bg_main w-full border-b-[1px] border-white shadow-md">
        <div className=" h-full px-4 flex justify-between items-center max-w-screen-2xl mx-[auto] ">
          <div className="h-full flex gap-4 items-center ">
            <Logo />
            <HeaderNav />
          </div>        
          <UserWidget />
        </div>
      </div>

      <main className="px-4 max-w-screen-2xl h-[100%] mx-[auto] py-10">
        {children || <Outlet />}
      </main>
    </div>
  );
};

export default PortalLayout;
